/* ============================================================
   Artikelüberschrift auf EINE Zeile bringen.

   Die Breite des Containers bleibt unangetastet — angepasst werden Zeichenabstand und
   Schriftgröße, in dieser Reihenfolge. Erst wird der Abstand bis zu einer Untergrenze
   zusammengezogen; reicht das nicht, wird zusätzlich die Schrift verkleinert. Abgeschnitten
   wird nichts: Es gibt keine Kürzung und kein overflow, der Titel steht immer vollständig da.

   Warum überhaupt ein Skript: CSS kann Text nicht auf eine Breite einpassen. clamp() rechnet
   mit der Fenstergröße, nicht mit der Textlänge — ein kurzer und ein langer Titel bekämen
   dieselbe Größe. Gemessen werden muss der fertig gesetzte Text, und das geht nur hier.

   Ohne JavaScript bleibt der Titel wie bisher mehrzeilig: nowrap setzt erst dieses Skript
   über die Klasse is-fitted. Das ist mit Absicht die Rückfallebene — ein umbrechender Titel
   ist harmlos, ein einzeiliger ohne Verkleinerung würde aus dem Container laufen.

   REGLER stehen als data-Attribute am Titel (siehe sections/main-article.liquid), damit sie
   sich ohne Eingriff in dieses Skript ändern lassen.
   ============================================================ */
(function () {
  'use strict';

  function init(el) {
    // Der Text braucht eine eigene Hülle: Nur so lässt sich seine TATSÄCHLICHE Breite
    // messen. Die Breite des <h1> ist immer die des Containers und sagt nichts darüber,
    // wie breit der Text darin wäre.
    var span = el.querySelector('[data-fit-inner]');
    if (!span) {
      span = document.createElement('span');
      span.setAttribute('data-fit-inner', '');
      while (el.firstChild) span.appendChild(el.firstChild);
      el.appendChild(span);
    }

    // Untergrenzen. Die Schrift darf bis auf diesen Anteil der natürlichen Größe schrumpfen,
    // der Zeichenabstand bis zu diesem Wert zusammenrücken.
    var minAnteil = parseFloat(el.dataset.fitMin) || 0.45;
    var minAbstand = el.dataset.fitSpacing || '-0.03em';

    function passt() {
      // 0.5px Luft: Bei gebrochenen Pixelbreiten meldet der Browser sonst je nach
      // Zoomstufe einen Überhang, den man gar nicht sieht — der Titel würde grundlos
      // kleiner gesetzt.
      return span.getBoundingClientRect().width <= el.clientWidth - 0.5;
    }

    function anpassen() {
      // Immer vom natürlichen Zustand aus messen. Ohne dieses Zurücksetzen würde jede
      // Fensteränderung auf dem bereits verkleinerten Stand aufsetzen und der Titel
      // schrumpfte Schritt für Schritt weiter, ohne je wieder zu wachsen.
      el.style.fontSize = '';
      el.style.letterSpacing = '';
      el.classList.add('is-fitted');

      if (passt()) return;

      // Stufe 1: Zeichenabstand zusammenziehen. Das fällt weit weniger auf als eine
      // kleinere Schrift und reicht bei den meisten Titeln schon aus.
      el.style.letterSpacing = minAbstand;
      if (passt()) return;

      // Stufe 2: Schriftgröße. Binäre Suche statt schrittweisem Verkleinern — sie braucht
      // rund zehn Messungen statt womöglich hundert, und jede Messung erzwingt ein neues
      // Layout.
      var natuerlich = parseFloat(getComputedStyle(el).fontSize) || 40;
      var unten = natuerlich * minAnteil;
      var oben = natuerlich;
      for (var i = 0; i < 12; i++) {
        var mitte = (unten + oben) / 2;
        el.style.fontSize = mitte + 'px';
        if (passt()) unten = mitte;
        else oben = mitte;
      }
      el.style.fontSize = unten + 'px';

      // Stufe 3 — der Rückfall. Passt der Titel selbst an der Untergrenze nicht, wird er
      // WIEDER MEHRZEILIG statt über den Rand zu laufen. Nachgemessen tritt das nur bei
      // sehr langen Titeln auf schmalen Bildschirmen auf: Bei 480px Fensterbreite lief ein
      // 94 Zeichen langer Titel links und rechts aus dem Container heraus, und weiter zu
      // verkleinern hätte ihn unlesbar gemacht (rund vier Pixel je Zeichen).
      //
      // Umbrechen ist hier das kleinere Übel, denn abgeschnitten werden darf nichts. Auf
      // dem Bildschirm, für den die Vorgabe gedacht ist, greift dieser Fall nicht.
      if (!passt()) {
        el.classList.remove('is-fitted');
        el.style.fontSize = '';
        el.style.letterSpacing = '';
      }
    }

    // Auf die Schriften warten: Solange die Roboto-Slab noch nicht da ist, misst der
    // Browser in einer Ersatzschrift mit anderen Breiten — das Ergebnis wäre falsch.
    anpassen();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(anpassen);

    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(anpassen, 100);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fit-title]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
